<div class=" w-50 md:w-100 relative rounded-xl overflow-hidden shadow-md">
  <img [src]="imagen" alt="Imagen beneficio" class="w-full h-40 object-cover" />
  <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 text-[#FCFEFF]">
    <div class="flex justify-between items-center">
      <div class="flex-1 overflow-hidden">
        <h3 class="headline-03 truncate">{{ nombre }}</h3>
          <p class="paragraph-small break-words">{{ descripcionTruncada }}</p>
      </div>
    <button class="self-end flex-shrink-0 w-6 h-6" (click)="goToBenefistInfo()">
      <img src="assets/logos/Arrow-Circle-Right.svg" class="w-6 h-6" />
    </button>
    </div>
  </div>
</div>